export default "__VITE_ASSET__CaQPDQ$m__"